module.exports = __webpack_public_path__ + "img/1-min.2d61fdec.jpg";